module.exports = __webpack_public_path__ + "img/lawsuitregistration.b61efdec.png";